exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breakpoints[data-v-57b40fe0] {\n  font-family: -apple-system, BlinkMacSystemFont,\"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif;\n  position: fixed;\n  bottom: 1.5625rem;\n  right: 1.5625rem;\n  background-color: #6166dc;\n  color: #f1f1f1;\n  font-size: 0.625rem;\n  text-transform: uppercase;\n  padding: 0.3125rem 0.625rem;\n  border-radius: 0.375rem;\n  text-align: center;\n  z-index: 500;\n  box-shadow: 0 0.25rem 0.5rem -0.0625rem rgba(0,0,0,.3),0 0.125rem 0.375rem -0.0625rem rgba(0,0,0,.07);\n}\n", ""]);

// exports
